import FieldEdit from './FieldEdit';
import FieldList from './FieldList';
import MasqueradePage from './MasqueradePage';
import SelectFieldOptionEditor from './SelectFieldOptionEditor';

export const components = {
  FieldList,
  FieldEdit,
  MasqueradePage,
  SelectFieldOptionEditor,
};
